import { useState } from "react";
import EmploymentListItem from "../ListItems/EmploymentListItem";
import EmploymentEditModal from "../Modals/EmploymentEditModal";
import BreadCrumb from "../Controls/BreadCrumb";
import { DateTime } from "luxon";
import UserData from "../Controls/UserData";
import Help from "../Controls/Help";
import { MdAddBox } from "react-icons/md";

function compareEmployments(a, b) {
  return DateTime.fromISO(a.StartDate) > DateTime.fromISO(b.StartDate) ? -1 : 1;
}

function loadEmployments() {
  const userData = UserData.UserData() || {};
  return [...(userData.employmentHistory || [])].sort(compareEmployments);
}

export default function EmploymentHistory() {
  const [userData, setUserData] = useState(() => UserData.UserData() || {});
  const [employments, setEmployments] = useState(loadEmployments);
  const [employmentModalId, setEmploymentModalId] = useState(null);

  function refreshList() {
    const next = UserData.UserData() || {};
    setUserData(next);
    setEmployments(loadEmployments());
  }

  function closeEmploymentModal() {
    setEmploymentModalId(null);
    refreshList();
  }

  if (!userData.employmentHistory) return <p>You have not entered any employment history</p>;

  return (
    <div className="pagebody">
      <BreadCrumb props={["Employment History"]} />
      <div className="tabbody">
        <h2>Employment History</h2>
        <Help id={2139} />
        <span className="listTitleIcons">
          <MdAddBox
            data-testid="employment-add"
            role="button"
            aria-label="Add employment"
            onClick={() => setEmploymentModalId(0)}
          />
        </span>
        <ul className="EmploymentList">
          {employments.map((employment) => (
            <EmploymentListItem
              key={employment.ID}
              employment={employment}
              employers={userData.employers}
              notices={userData.notices}
              onEdit={(id) => setEmploymentModalId(id)}
            />
          ))}
        </ul>
      </div>
      {employmentModalId !== null ? (
        <EmploymentEditModal
          employmentId={employmentModalId}
          onClose={closeEmploymentModal}
        />
      ) : null}
    </div>
  );
}
